import * as angular from 'angular';
import CoreModule from './../core/core.module';
import SharedModule from './../shared/shared.module';
import productRoutes from './product.routes';
import ProductService from './product.service';
import ProductFilterService from './product-filter/product-filter.service';
import {ProductFilterOptionModel, ProductFilterSelectModel} from './product-filter/product-filter.model';
import productListComponent from './product-list/product-list.component';
import productDetailComponent from './product-detail/product-detail.component';
import productRelatedComponent from './product-related/product-related.component';
import productCheckComponent from './product-check/product-check.component';
import productCheckItemComponent from './product-check/product-check-item/product-check-item.component';
import productCheckTableComponent from './product-check/product-check-table/product-check-table.component';
import productImagesComponent from './product-images/product-images.component';
import productFilterFormComponent from './product-filter/product-filter-form/product-filter-form.component';
import productCheckAggregateComponent from './product-check/product-check-aggregate/product-check-aggregate.component';
import PRODUCT_CONSTANT from './product.constant';

export default angular
  .module('FHL.product', [
    CoreModule,
    SharedModule,
  ])
  .config((RouterServiceProvider) => {
    RouterServiceProvider.configureStates(productRoutes);
  })
  .service('ProductFilterService', ProductFilterService)
  .service('ProductService', ProductService)
  .value('ProductFilterOptionModel', ProductFilterOptionModel)
  .value('ProductFilterSelectModel', ProductFilterSelectModel)
  .value('PRODUCT_CONSTANT', PRODUCT_CONSTANT)
  .component('productList', productListComponent)
  .component('productDetail', productDetailComponent)
  .component('productRelated', productRelatedComponent)
  .component('productCheck', productCheckComponent)
  .component('productCheckItem', productCheckItemComponent)
  .component('productCheckTable', productCheckTableComponent)
  .component('productImages', productImagesComponent)
  .component('productFilterForm', productFilterFormComponent)
  .component('productCheckAggregate', productCheckAggregateComponent)
  .name;



// WEBPACK FOOTER //
// ./src/app/product/product.module.js